/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaFinding model module.
 * @module model/AqaFinding
 * @version v0
 */
export default class AqaFinding {
  /**
   * Constructs a new <code>AqaFinding</code>.
   * @alias module:model/AqaFinding
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaFinding</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaFinding} obj Optional instance to populate.
   * @return {module:model/AqaFinding} The populated <code>AqaFinding</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaFinding();
      if (data.hasOwnProperty('ename'))
        obj.ename = ApiClient.convertToType(data['ename'], 'String');
      if (data.hasOwnProperty('metric'))
        obj.metric = ApiClient.convertToType(data['metric'], Object);
    }
    return obj;
  }
}

/**
 * @member {String} ename
 */
AqaFinding.prototype.ename = undefined;

/**
 * @member {Object} metric
 */
AqaFinding.prototype.metric = undefined;

